/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "./";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 3);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(12);
__webpack_require__(13);
__webpack_require__(14);
__webpack_require__(15);
__webpack_require__(16);
__webpack_require__(17);
__webpack_require__(18);

__webpack_require__(19);
__webpack_require__(20);

var dialog = __webpack_require__(21);

var QBDown = __webpack_require__(24);
var myGifts = __webpack_require__(25);
var showPrize = __webpack_require__(26);
var shareGetChance = __webpack_require__(27);
var notSub = __webpack_require__(28);
var activtyEnd = __webpack_require__(29);
var userContact = __webpack_require__(30);

var answerEnd = __webpack_require__(31);
var answerNum = __webpack_require__(32);
var littleFollow = __webpack_require__(33);
var skin = __webpack_require__(34);

var userInfoObj = JSON.parse(sessionStorage.getItem("userInfo"));
var errorCode = __webpack_require__(35);
var thanks = __webpack_require__(36);
var nochance = __webpack_require__(37);

function mask(type, title, msg, headsrc, width, height) {
  if (type === "QBrowser") {
    console.trace();
    dialog({
      width: 550,
      height: 280,
      className: 'activtyEnd',
      body: QBDown({
        title: title,
        msg: msg
      }),
      onclose: function onclose() {},
      onshow: function onshow() {
        if (msg == '请前往电脑参与') {
          $('.pcqb-QBDown-btn').hide();
        }
      }
    }).show();
  } else if (type === "myGifts") {
    dialog({
      width: 820,
      height: 428,
      body: myGifts({}),
      className: 'mygifts',
      onclose: function onclose() {},
      onshow: function onshow() {
        setTimeout(function () {
          $(".qtips").mouseover(function () {
            $(this).css("overflow", "visible");
          });
          $(".duiRule").mouseout(function () {
            $(".qtips").css("overflow", "hidden");
          });
          $(".duiRuleQr").mouseout(function () {
            $(".qtips").css("overflow", "hidden");
          });
          $(".qtips").mouseout(function () {
            $(this).css("overflow", "hidden");
          });

          $(".qtips1").mouseover(function () {
            $(this).css("overflow", "visible");
            $(".qrcode").css("visibility", "visible");
          });
          $(".qtips1").mouseout(function () {
            $(".qrcode").css("visibility", "hidden");
          });
        }, 400);
      }
    }).show();
  } else if (type === "showPrize") {
    dialog({
      width: 550,
      height: 590,
      body: showPrize({})
    }).show();
  } else if (type === "shareGetChance") {
    dialog({
      width: 550,
      height: 280,
      className: 'activtyEnd',
      body: shareGetChance({}),
      onclose: function onclose() {
        if (lottery.showNotShare) {
          mask('shareGetChance');
          lottery.showNotShare = false;
        }
      },
      onshow: function onshow() {}
    }).show();
  } else if (type === "notSub") {
    dialog({
      width: 550,
      height: 280,
      body: notSub({}),
      onclose: function onclose() {
        if (lottery.showNotShare) {
          mask('shareGetChance');
          lottery.showNotShare = false;
        }
      }
    }).show();
  } else if (type === "activtyEnd") {
    dialog({
      width: 550,
      height: 280,
      className: 'activtyEnd',
      body: activtyEnd({
        title: title,
        msg: msg
      }),
      onclose: function onclose() {
        if (msg == "参加测试可额外获得1次抽奖机会哦") {
          console.log("scroll to anchor!!!!!!!!!!");
          $("html,body").animate({
            scrollTop: 830
          }, 200);
        }
      }
    }).show();
  } else if (type === "userCon") {
    dialog({
      width: 550,
      height: 485,
      body: userContact({
        title: title,
        msg: msg
      }),
      onclose: function onclose() {

        var userInfo = {
          "userName": $("#userName").val(),
          "phoneNum": $("#phoneNum").val(),
          "provinceId_m": $("#provinceId_m").val(),
          "cityId_m": $("#cityId_m").val(),
          "areaId_m": $("#areaId_m").val(),
          "detailAddr": $("#detailAddr").val(),
          "zipCode": $("#zipCode").val()
        };
        sessionStorage.setItem("userInfo", JSON.stringify(userInfo));
      },
      onshow: function onshow() {
        if (!window.userInfoObj) {
          //非空校验
          return;
        }
        setTimeout(function () {
          $("#userName").val(userInfoObj["userName"]);
          $("#phoneNum").val(userInfoObj["phoneNum"]);
          $("#provinceId_m").val(userInfoObj["provinceId_m"]);
          $("#cityId_m").val(userInfoObj["cityId_m"]);
          $("#areaId_m").val(userInfoObj["areaId_m"]);
          $("#detailAddr").val(userInfoObj["detailAddr"]);
          $("#zipCode").val(userInfoObj["zipCode"]);
        }, 500);
      }
    }).show();
  } else if (type === "answerEnd") {
    dialog({
      width: 550,
      height: 280,
      body: answerEnd({
        title: title,
        msg: msg
      })
    }).show();
  } else if (type === "answerNum") {
    dialog({
      width: 550,
      height: 280,
      body: answerNum({
        headsrc: headsrc,
        title: title,
        msg: msg
      }),
      onshow: function onshow() {
        window.setTimeout(function () {
          if (!window.lottery.isVoted) {
            $('.tryluck').show();
          }
        }, 40);
      }
    }).show();
  } else if (type === "errorCode") {
    dialog({
      width: 550,
      height: 280,
      body: errorCode({
        title: title,
        msg: msg
      }),
      onshow: function onshow() {},
      onclose: function onclose() {}
    }).show();
  } else if (type === "littleFollow") {
    dialog({
      width: 550,
      height: 280,
      className: 'littleFollow',
      body: littleFollow({
        title: title,
        msg: msg

      }),
      onshow: function onshow() {},
      onclose: function onclose() {}
    }).show();
  } else if (type === "thanks") {
    dialog({
      width: 550,
      height: 280,
      className: 'thanks',
      body: thanks({
        title: title,
        msg: msg

      }),
      onshow: function onshow() {},
      onclose: function onclose() {}
    }).show();
  } else if (type === "nochance") {
    dialog({
      width: 550,
      height: 280,
      className: 'thanks',
      body: nochance({
        title: title,
        msg: msg

      }),
      onshow: function onshow() {},
      onclose: function onclose() {}
    }).show();
  } else if (type === "errorCode") {
    dialog({
      width: 550,
      height: 280,
      body: errorCode({
        title: title,
        msg: msg
      }),
      onshow: function onshow() {},
      onclose: function onclose() {}
    }).show();
  } else if (type === "skin") {
    dialog({
      width: 550,
      height: 280,
      className: 'activtyEnd',
      body: skin({
        title: title,
        msg: msg
      }),
      onclose: function onclose() {},
      onshow: function onshow() {
        if (msg == '请前往电脑参与') {
          $('.pcqb-QBDown-btn').hide();
        }
      }
    }).show();
  }
}

module.exports = mask;

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var guid = void 0;
var mask = __webpack_require__(0);

function request() {}
//发送请求
request.send = function (obj, cb) {
  if (!guid) {
    try {
      guid = qbsdk.getGuid(); //window.external.getGuid().split("-").join("")
    } catch (e) {}
  }
  if (qbsdk.isQB() /*api.isQB*/) {
      zUtil.ensureLogin(function () {
        obj.guid = guid;
        zHttp.send(obj, function (res) {
          if (res.ret == 10002) {
            qq.login.open();
          } else if (res.ret == 10004) {
            //todo
          } else {
            cb && cb(res);
          }
        });
      });
    }
  // else {
  //   mask("QBrowser")
  // }
};

module.exports = request;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* iBorad
 ----------------------------------------------------------------*/
module.exports = iBorad;

function iBorad(element, options) {
  this.defaultOptions = {
    type: 'left',
    speed: 1500,
    cycle: 3600
  };
  this.options = options || {};
  this.options = $.extend({}, this.defaultOptions, this.options);

  this.$element = $(element);
}
var maxWidth_iBorad_item = 0;
iBorad.prototype = {
  constructor: iBorad,
  init: function init() {
    var self = this,
        boxTotalWidth = 0;

    self.$active = this.$element.find('.board-slide .box-active');
    if (self.options.type == 'left') {
      self.$element.find('.board-slide .box').each(function () {
        if ($(this).outerWidth() >= maxWidth_iBorad_item) {
          maxWidth_iBorad_item = $(this).outerWidth();
          //console.log($(this).outerWidth());
        }
        boxTotalWidth += $(this).outerWidth();
      });
      self.$element.find('.board-slide .box').each(function () {
        $(this).width(maxWidth_iBorad_item + 10);
      });
      // self.$element.find('.board-slide').css({width: boxTotalWidth})
    }
    self.next();
    self.isCycle || self.cycle();
  },
  next: function next() {
    var self = this,
        $target = self.$active.next()
    // , curBoxWidth = self.$active.outerWidth()

    ,
        $copyBox = self.$active.clone().removeClass('box-active'),
        slideOpt,
        slideValue;

    switch (self.options.type) {
      case 'left':
        slideValue = '-' + (maxWidth_iBorad_item + 10) + 'px'; // +10 动画移动的距离 加大 补偿margin 最好位置
        slideOpt = {
          marginLeft: slideValue
        };
        break;
      case 'top':
        slideValue = '-' + self.$active.height() + 'px';
        slideOpt = {
          marginTop: slideValue
        };
        break;
      default:
        break;
    }
    self.$active.animate(slideOpt, self.options.speed, 'linear', function () {
      $copyBox.appendTo(self.$element.find('.board-slide'));
      $(this).remove();
    });
    $target.addClass('box-active');
    self.$active = $target;
  },
  cycle: function cycle() {
    var self = this;
    if (!self.isCycle) {
      self.isCycle = setInterval(function () {
        self.next();
      }, self.options.cycle);
    }
  }
};

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var config = __webpack_require__(4);
var utils = __webpack_require__(44);
var request = __webpack_require__(1);
var iBorad = __webpack_require__(2);
__webpack_require__(45);
var mask = __webpack_require__(0);

_qblog.setting({ key: 20014, tcss: true });
_qblog.wsd.click("LOVEAPARTMENT.PV");

//AMS新集成
zHttp.baseUrl = "http://iyouxi3.vip.qq.com/ams3.0.php";
//活动地址 不带任何参数
var _pageUrl = location.protocol + '//' + location.host + location.pathname;
//main
var Page = qv.zero.extend(qv.zero.AbstractPage, {
  // 项目ID
  userJsonID: 300495,
  loadExtHandler: true,
  init: function init() {
    Page.superclass.init.apply(this, arguments);
    if (!navigator.userAgent.match(/Android|iPhone|iPad|iPod|webOS|BlackBerry|Windows Phone/i) && !qbsdk.isQB()) {
      mask("QBrowser", '本活动为QQ浏览器专属活动', '请使用QQ浏览器参加');
    }
  },
  initEvent: function initEvent() {
    Page.superclass.initEvent.apply(this, arguments);
    $('body').on('click', 'a[href="#"]', function (e) {
      e.preventDefault();
    });
    qq.login.bind('login', function () {
      lottery.firstLogin();
      lottery.getVoted();
      $(".lucktime").show();
      $(".loginQQ").hide();
    });
    qq.login.bind('logout', function () {
      $(".lucktime").hide();
      $(".loginQQ").show();
    });
    if (qq.login.getUin()) {
      lottery.firstLogin();
      lottery.getVoted();
      $(".lucktime").show();
      $(".loginQQ").hide();
    } else {
      $(".lucktime").hide();
      $(".loginQQ").show();
    }

    $(".feed .feedBack").click(function () {
      _qblog.wsd.click("LOVEAPARTMENT.SUPPORT");
    });
    // lottery.getVideosInfo();
  }

});
window.page = new Page();

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var config = {
  'title': '《爱情公寓》免费电影票放肆抢',
  'keywords': '爱情公寓，电影票',
  'description': 'QQ浏览器桌面版用户专属特权——QQ浏览器请你免费看《爱情公寓》大电影，海量电影票、观影红包放肆抢'
};

config.layout = __webpack_require__(5);

__webpack_require__(7);

config.qbtop = [__webpack_require__(8)];

config.qbheader = [];

config.qbbody = [__webpack_require__(10), __webpack_require__(38), __webpack_require__(40)];

config.qbfooter = [__webpack_require__(42)];

module.exports = config;

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(6);

/***/ }),
/* 6 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 7 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

;
(function (global, document, $) {

  __webpack_require__(9);

  var COOKIE_CONFIG = {
    domain: 'tq.qq.com',
    path: '/',
    expires: 24 * 60 * 60
  };

  function isQQBrowser() {

    return !/Trident/i.test(navigator.userAgent) && /QQBrowser/i.test(navigator.userAgent) && chrome && window.external && window.external.getVersion ? true : false;
  }

  // 初始化登录&用户信息UI
  function initLoginUI(option) {

    var showAvatar = false;
    var loginUIHtml = {
      notLogin: '你好，<a href="#" class="bt_login">请登录</a>',
      isLogin: '<span class="user_nick" title="欢迎">{nick}</span><a id="header-logout" class="mod_st_logout" href="#" title="退出">退出</a>',
      isLoginIcon: '<img class="user_icon" src="{avatar}"/><span class="user_nick">{nick}</span><a id="header-logout" class="mod_st_logout" href="#" title="退出">退出</a>'
    };

    // 绑定登录事件
    var _setLogin = function _setLogin(option) {
      showAvatar = !!option.showAvatar;
      // 登录
      qq.login.bind('login', function () {
        var _uin = qv.cookie.get('_uin');
        var _nick = qv.cookie.get('_nick');
        var _avatar = qv.cookie.get('_avctar');
        // 如果cookie里有_uin，_nick等信息，更新，否则去；拉取
        if (_uin === qq.login.getUin() && _nick && _avatar) {
          _fillUserInfo(_nick, _avatar);
        } else {
          var options = {
            url: 'http://iyouxi3.vip.qq.com/ams3.0.php',
            dataType: 'jsonp',
            data: {
              _c: 'User',
              field: "uin,nickname,faceurl",
              g_tk: qq.security.getCSRFToken()
            },
            success: function success(res, textStatus, jqXHR) {
              qv.cookie.set('_uin', res.data.uin, COOKIE_CONFIG);
              qv.cookie.set('_nick', res.data.nickname, COOKIE_CONFIG);
              qv.cookie.set('_avctar', res.data.faceurl, COOKIE_CONFIG);
              _fillUserInfo(res.data.nickname, res.data.faceurl);
              if (res.data.nickname === undefined) {
                qq.login.logout();
              }
            }
          };
          $.ajax(options);
        }
      });
      // 退出登录
      qq.login.bind('logout', function () {
        pt.logout();
        qv.cookie.clear('_uin');
        qv.cookie.clear('_nick');
        qv.cookie.clear('_avctar');
        _fillUserInfo();
      });
      if (qq.login.getUin()) {
        qq.login.trigger('login');
      } else {
        _fillUserInfo();
      }
    };

    // 设置用户信息到dom
    var _fillUserInfo = function _fillUserInfo(nick, faceurl) {
      var _arHtml = [];
      var _data = {};
      if (nick) {
        _data.nick = qv.string.encodeHTML(nick);
      }
      if (faceurl) {
        _data.avatar = faceurl;
      }
      if (!qq.login.getUin()) {
        _arHtml.push(loginUIHtml.notLogin);
      } else {
        if (showAvatar) {
          _arHtml.push(qv.string.format(loginUIHtml.isLoginIcon, _data));
        } else {
          _arHtml.push(qv.string.format(loginUIHtml.isLogin, _data));
        }
      }
      $('#navUserInfo').html(_arHtml.join(''));
      if (showAvatar) {
        $('#navUserInfo .user_icon').show();
      }
      _bindEvent();
    };
    // events: 登录 | 退出登录
    var _bindEvent = function _bindEvent() {
      $('.bt_login').click(function (e) {
        e.preventDefault();
        pt.showPtui();
      });
      $('.mod_st_logout').click(function (e) {
        e.preventDefault();
        qq.login.logout();
      });
      qq.login.trigger('navrendered');
    };

    qq.login.open = function () {
      pt.showPtui();
    };
    _setLogin(option);
  }

  // 加载&初始化登录组件ptlogin
  function initPtlogin(option) {

    var ptloginParam = {
      'appid': 1600000073,
      'daid': 5,
      's_url': location.href,
      'style': 20,
      'protocol': 'https:',
      'domain': 'qq.com',
      'border_radius': 1,
      'target': 'top',
      'maskOpacity': 40
    };
    if ((typeof option === 'undefined' ? 'undefined' : _typeof(option)) === 'object' && option.qzoneDaid) {
      ptloginParam['daid'] = 5;
    }
    $.getScript('https://xui.ptlogin2.qq.com/js/ptlogin_v1.js', function () {
      pt.setParams(ptloginParam);
    });
  }

  // header初始化
  function initHeader(option) {

    // 加载&初始化登录组件ptlogin
    initPtlogin(option);
    initLoginUI(option);

    // 加载页头UI
    // var headerClass = option.isWhiteStyle ? '' : 'black';
    var $headerQBEle = $('#headerQB');
    // $('#modHeader div.mod-act-header').addClass(headerClass);

    // 非QB显示下载按钮
    if (!isQQBrowser()) {
      $headerQBEle.css('display', 'inline');
    }
    if ((typeof option === 'undefined' ? 'undefined' : _typeof(option)) === 'object') {
      $headerQBEle.attr('href', option.downloadLink || 'https://dldir1.qq.com/invc/tt/QQBrowser_Setup_QB10.exe');
      if (option.report) {
        $headerQBEle.onclick = function () {
          _qblog.tcss.click(option.report);
        };
      }
    }
  }

  initHeader({
    // 是否白色背景风格 false黑色|true白色（可选，默认false）
    // isWhiteStyle: true,
    // 用户头像是否显示（可选，默认false）
    showAvatar: true,
    // 下载QB按钮的链接 默认：特权中心QB包（可选）
    downloadLink: 'https://dldir1.qq.com/invc/tt/QQBrowser_Setup_QB10.exe',
    // 点击流数据上报（可选）
    report: 'BROWSER.EVENTS.TOPQBDOWNLOADCLICK'
  });
})(undefined, document, jQuery);

/***/ }),
/* 9 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(11);
var request = __webpack_require__(1);
var iBorad = __webpack_require__(2);
var mask = __webpack_require__(0);
try {
  var tguid = qbsdk.getServerGuid(); //window.external.getFavSyncGuid();
} catch (e) {}
var strHref = location.href;
var intPos = strHref.indexOf("?");
var strRight = strHref.substr(intPos + 1);
var arrTmp = strRight.split("&");
var isMecenter = false;

console.log(arrTmp.length);
for (var i = 0; i < arrTmp.length; i++) {
  var arrTemp = arrTmp[i].split("=");
  if (arrTemp[0].toUpperCase() == "ADTAG") {
    console.log(arrTemp[1]); //mecenter
    if (arrTemp[1] == 'mecenter') {
      isMecenter = true;
    }
  }
}

function Lottery() {
  var _$ = $;
  var _that = this;
  this.inGame = false;
  this.showNotShare = false;
  this._pageUrl = location.protocol + '//' + location.host + location.pathname;

  this.isFollowed = false;
  this.isShared = false;
  this.isVoted = false;

  //查询是否投票过 304087
  this.getVoted = function () {
    request.send({
      'actid': 304084
    }, function (res) {
      if (res.ret === 0) {
        if (res.data.op.count >= 1) {
          //分享过
          _that.isVoted = true;

          console.log('已经投票过--');
        } else {
          //没分享过
          _that.isVoted = false;
          console.log('没有投票过--');
        }
      }
    });
  };
  //首次登录加机会
  this.firstLogin = function () {
    request.send({
      'actid': 304087
    }, function (res) {
      if (res.ret === 0) {

        console.log('没有登录过--');
      } else if (res.ret == 10603) {
        console.log('已经登录过--');
      } else {
        console.log('exception code -->' + res.ret);
      }
      window.lottery.setMoney();
    });
  };

  // 抽奖
  this.getLucky = function () {
    if (!qq.login.getUin()) {
      qq.login.open();return;
    }
    var _that = this;
    if (_that.inGame) {
      //正在抽奖
      console.log('is --- going---!!!!!!!!!!!!!!');
      return;
    }
    if (new Number($("#money").text()) == 0) {
      //0 次点击时判断 是否分享过
      if (this.isVoted) {
        mask('nochance', '抽奖机会已用完，', '为选手投票可额外获得1次抽奖机会哦！');
        return;
      } else {
        mask('activtyEnd', '抽奖机会已用完，', '参加测试可额外获得1次抽奖机会哦！');
        return;
      }
    }

    _qblog.wsd.click("LOVEAPARTMENT.LUCKY");
    _that.inGame = true; //开始发请求 然后开始抽奖
    request.send({
      // 抽奖id
      'actid': 300499
    }, function (res) {
      // var res = {
      //   data: {
      //     join: {
      //       level: 4
      //     },
      //     op: {
      //       cdkey: '111111111111111111',
      //       diamonds: 3,
      //       name: '一年假期',
      //       count: 0
      //     }
      //   },
      //   ret: 0
      // }
      if (res.ret === 0) {
        //展示奖品
        _that.setMoney();
        //  _qblog.wsd.click("LOVEAPARTMENT.LUCKY.OK")
        var key = res.data.op.diamonds;
        var cdkey = res.data.op.cdkey;
        if (key <= 3) {
          openPrizeMask(key, cdkey); //7 是谢谢惠顾
          _that.inGame = false;
        } else {
          // 如果是谢谢惠顾什么也不谈
          if (key == 4) {
            _that.inGame = false;
            if (window.lottery.isVoted) {
              mask('littleFollow', '', '好遗憾，还差一点点就中奖啦~');
            } else {
              mask('thanks', '', '');
            }
          } else {
            console.warn("wrong-prize-leverl---!!!");
          }
        }
      } else if (res.ret === 20801) {
        //没有机会啦
        // 查询今天是否分享过
        request.send({
          'actid': 296669
        }, function (res) {
          if (res.ret === 0) {
            //分享过
            if (res.data.op.count >= 1) {
              mask('activtyEnd', '今日抽奖机会已到上限啦，明天再分享依然', '可获得额外机会！');
            } else {
              mask('shareGetChance');
            }
          }
          _that.inGame = false;
        });
      } else if (res.ret === 10002) {
        qq.login.open();
        _that.inGame = false;
      } else if (res.ret == 10001 || res.ret == 10004) {
        mask('activtyEnd', '活动已经结束，敬请期待更多QQ浏览器特权活动！', '');
        _that.inGame = false;
      }
    });
  };

  this.vote = function () {
    var _that = this;
    _qblog.wsd.click("LOVEAPARTMENT.VOTE");
    request.send({
      'actid': 300528 //投票增加机会
    }, function (res) {
      if (res.ret === 0) {
        //分享成功
        _that.setMoney();
        //  _qblog.wsd.click("EMPRESS.SUCCESS")
      } else {
        console.log(res);
      }
      window.setTimeout(function () {
        _that.isVoted = true; //给弹窗一个时间 显示第一次 答题后的提示
      }, 600);
      _that.isVoted = true;
    });
  };
  this.testXu = function (index) {
    if (index < 7) {
      openPrizeMask(index, "xxxxx"); //7 是谢谢惠顾
    } else if (index == 7) {
      if (window.lottery.isVoted) {
        mask('littleFollow', '', '好遗憾，还差一点点就中奖啦~');
      } else {
        mask('thanks', '', '');
      }
    } else if (index == 9) {
      // 如果是谢谢惠顾什么也不谈
      mask('shareGetChance');
      // mask('errorCode','','订阅请求失败，错误码：xxxxx');
    } else if (index > 9) {
      mask('answerNum', '测试结果：100分', '');
      // mask('nochance', '抽奖机会已用完，', '为选手投票可额外获得1次抽奖机会哦！');
      //  $("html,body").animate({
      //    scrollTop: 830
      //  }, 200);
    }

    //openPrizeMask(index,"xxxxx");
  };
  function openPrizeMask(key, code) {
    var prizeArr = [0, '爱情公寓免费电影票兑换码', '猫眼电影票代金券', '个人中心 2 积分', '腾讯视频VIP季卡', 'Q币X10个', 'Q币X5个'];
    var title = prizeArr[key];
    var str = '';
    str += '<div class="tit">恭喜获得 ' + title + '</div>';
    //四等奖月卡添加cdkey
    str += '<div class="mask-show-prize-img' + key + ' mask-show-prize-img"></div>';
    // console.log(key,"=======",res.data,"----------",title)
    switch (key) {
      case 1:
        str += '<div class="show-prize-code">兑换码:' + code + '</div>';
        str += '<div class="show-prize-get-context-img-2 close"><a href="#" class="">我知道了</a>';break;
      case 2:
        str += '<div class="show-prize-qrcode">' + '<img src="http://stdl.qq.com/stdl/qb/kp/la_qrcode.png">' + '</div>';
        str += '<div class="show-prize-get-context-img-2 close"><a href="#" class="">我知道了</a>';
        break;
      case 3:
        str += '<div class="show-prize-code-null">前往个人中心兑换礼品吧</div>';
        str += '<div class="show-prize-get-context-img close margin-b16"><a href="http://i.browser.qq.com/" target="_blank" class="">去兑换</a>';
        break;
      case 4:
        str += '<div class="show-prize-code-null"></div>';
        str += '<div class="show-prize-get-context-img close"><a href="#" class="">我知道了</a>';
        break;

      case 5:
      case 6:
        str += '<div class="show-prize-code-null"></div>';
        str += '<div class="show-prize-get-context-img close"><a href="#" class="">我知道了</a>';
        break;
      default:
        str += '<div class="show-prize-get-context-img close"><a href="#" class="">我知道了</a> ';
    }

    switch (key) {
      case 1:
        str += '</div><div class="rule"><p>使用说明：</p><div class="rule-juli"></div>';
        str += '<p class="import">● 兑换码有效兑换时间：2018年9月9日23:59:59前；</p>';
        str += '<p>● 兑换电影票请前往淘票票平台进行兑换，仅限兑换单片《爱情公寓》售价2D不高于55元的场次；</p>';
        str += '<p>● 想再来1张，你还可以前往个人中心凭已有积分换取更多哦</p>';
        str += '</div>';break;
      case 2:
        str += '</div><div class="rule"><p>奖品说明：</p><div class="rule-juli"></div>';
        str += '<p class="import">● 同一用户仅限领取一张电影抵用券；</p>';
        str += '<p>● 电影抵用券仅限在线选座购买《爱情公寓》使用，该券不可与平台其他优惠同享，领取后7日内有效；</p>';
        str += '<p>● 领取的电影抵用券可在美团客户端【我的】-【红包/卡券】中查看，或猫眼客户端【我的】-【优惠券】中查看</p>';
        str += '</div>';break;
      case 3:
        str += '</div><div class="rule"><p>奖品说明：</p><div class="rule-juli"></div>';
        str += '<p class="import">● 同一用户仅限领取一张电影抵用券；</p>';
        str += '<p>● 电影抵用券仅限在线选座购买《爱情公寓》使用，该券不可与平台其他优惠同享，领取后7日内有效；</p>';
        str += '<p>● 领取的电影抵用券可在美团客户端【我的】-【红包/卡券】中查看，或猫眼客户端【我的】-【优惠券】中查看</p>';
        str += '</div>';break;
    }
    // str += '</div><div class="rule"><p>奖品说明：</p><div class="rule-juli"></div>';
    // str += '<p class="import">● 同一用户仅限领取一张电影抵用券；</p>';
    // str += '<p>● 电影抵用券仅限在线选座购买《爱情公寓》使用，该券不可与平台其他优惠同享，领取后7日内有效；</p>';
    // str += '<p>● 领取的电影抵用券可在美团客户端【我的】-【红包/卡券】中查看，或猫眼客户端【我的】-【优惠券】中查看</p>';
    // str += '</div>';

    mask('showPrize', '', '');
    setTimeout(function () {
      $('.dialog-show-prize .gifts').html(str);
    }, 100);
  }

  //查询中奖记录
  var isquery = false;
  this.queryRecord = function () {
    if (this.inGame) return;
    if (isquery) {
      return; //防止重复点击
    }
    isquery = true;
    _qblog.wsd.click("LOVEAPARTMENT.QUERYRECORD.CLICK");
    setTimeout(function () {
      isquery = false;
    }, 300);
    request.send({
      // zeroj 查询获奖记录
      'actid': 300530
    }, function (res) {
      if (res.ret == 0) {
        var msg = res.data.op;
        // var msg = [{
        //   val: {
        //     level: 2,
        //     time: 1521966470,
        //     name: "电影代金券",
        //     info: "11111111111111"
        //   }
        // }]
        var str = '';
        if (msg.length !== 0) {
          str = '<li><span>中奖日期</span><span>奖品名称</span><span>奖品详情</span><span>操作</span></li>';
          for (var i = 0; i < msg.length; i++) {
            if (msg[i].val.level == 2) {
              //二维码
              str += '<li><span>' + qv.date.format("Y.m.d", msg[i].val.time * 1000) + '</span><span>' + msg[i].val.name + '</span>';
              str += '<span>二维码 <i class="qtips1"> ？<span class="qrcode">';
              str += '<div class="erwei">' + '<img src="http://stdl.qq.com/stdl/qb/kp/la_qrcode.png" />' + '</div> ';
              str += '</span></i></span>';
              str += '<span>请扫描</span></li>';
            } else if (msg[i].val.level == 1) {
              // 去兑换电影票
              str += '<li><span>' + qv.date.format("Y.m.d", msg[i].val.time * 1000) + '</span><span>' + msg[i].val.name + '</span><span>兑换码：' + msg[i].val.info;
              str += ' <i class="qtips"> ？<span class="duiRule">';
              str += '<ul><li><p>活动规则：</p></li>\
                                              <li><p>● 兑换码有效兑换时间：2018年9月9日23:59:59前；</p></li>\
                                              <li><p>● 兑换电影票请前往淘票票平台进行兑换，仅限兑换单片《爱情公寓》售价2D不高于55元的场次；</p></li>\
                                              <li><p>● 想再来1张，你还可以前往个人中心凭已有积分换取更多哦</p></li>\
                                          </ul>';
              str += '</span></i></span>';
              str += '<span><a href="https://dianying.taobao.com/" class="userCon" target="_blank">去兑换</a></span></li>';
            } else if (msg[i].val.level == 3) {
              // 虚拟奖品 2积分
              str += '<li><span>' + qv.date.format("Y.m.d", msg[i].val.time * 1000) + '</span><span>' + msg[i].val.name + '</span>';
              str += '<span>虚拟奖品 <i class="qtips"> ？<span class="duiRule">';
              str += '<ul><li><p>活动规则：</p></li>\
                                              <li><p>● Q币会在活动结束后一个月内，统一充值到参与活动的QQ号</p></li>\
                                              <li><p>● 视频会员、优惠券、现金券等虚拟奖品中奖后，需立即前往指定产品官方页面进行兑换</p></li>\
                                              <li><p>● 实物奖品将在活动结束后一月内统一发货，请在中奖后立即填写有效联系方式，因用户提供的联系地址不详以致奖品回寄的情况，将不予补送；奖品图片仅供参考，一切以实物为准</p></li>\
                                          </ul>';
              str += '</span></i></span>';
              str += '<span>自动到账</span></li>';
            }
          }
        } else {
          str += '<div id="space">';
          str += '<img src="http://stdl.qq.com/stdl/qb/kp/space.png">';
          str += '<p>暂无获奖记录，快去参加活动吧</p>';
          str += '</div>';
        }

        mask('myGifts');
        $('.dialog-myGifts .giftRecord .gifts').html(str);
      } else if (res.ret == 10002) {
        qq.login.open();
      } else if (res.ret == 10001 || res.ret == 10004) {
        mask('activtyEnd', '活动已经结束，敬请期待更多QQ浏览器特权活动！', '');
      } else {
        zHttp.showResponse(res, res.actid, $.noop);
      }
    });
  };
  //设置抽奖次数 从后台接口返回
  this.setMoney = function () {
    //@@
    request.send({
      'actid': 304092
    }, function (res) {
      if (res.ret == 0) {
        var m = res.data.op;
        _that.luckNum = m;
        console.log('luckNum --->' + m);
        $('#money').text(m);
      }
    });
  };
  this.setUserContact = function () {
    userAddress.submitUserInfo("userName", "phoneNum", "detailAddr", "zipCode", function () {
      _$(".dialog-user-contact #success-submit").fadeIn(500).fadeOut(500);
    });
  };
  this.getUserContact = function () {
    userAddress.getUserInfo(function (res) {
      $('#userCon .userInfo').html(userAddress.tempContact(res));
    });
    mask('userCon');
  };
}
window.lottery = new Lottery();

/***/ }),
/* 11 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 12 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 13 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 14 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 15 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 16 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 17 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 18 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 19 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 20 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var csss = __webpack_require__(22);
var template = __webpack_require__(23);
module.exports = Dialog;

var default_options = {
  body: '',
  width: 380,
  height: 0,
  className: 'cus',
  maskclose: true,
  onclose: null,
  onshow: null
};

var $body = $(document.body);
function disabledMouseWheel() {
  function scrollFunc(evt) {
    return false;
  }
  if (document.addEventListener) {
    document.addEventListener('DOMMouseScroll', scrollFunc, false);
  } //W3C
  window.onmousewheel = document.onmousewheel = scrollFunc; //IE/Opera/Chrome
}
function ableMouseWheel() {
  function scrollFuncRecover(evt) {
    return true;
  }
  if (document.addEventListener) {
    document.addEventListener('DOMMouseScroll', scrollFuncRecover, false);
  } //W3C
  window.onmousewheel = document.onmousewheel = scrollFuncRecover; //IE/Opera/Chrome
}
function Dialog(opts) {
  if (!(this instanceof Dialog)) return new Dialog(opts);
  this.opts = $.extend({}, default_options, opts);
  this._createElement();
  this._initEvents();
}

Dialog.prototype = {

  show: function show() {
    var self = this,
        opts = self.opts,
        $el = self.$el,
        $box = self.$box;
    $box.css({
      'width': opts.width,
      'margin-left': -opts.width / 2
    });
    $el.show();

    var h = opts.height > 0 ? opts.height : $box.height();
    self.$box.css({
      'height': h,
      'top': -h / 2,
      'margin-top': -h / 2
    });
    disabledMouseWheel();
    setTimeout(function () {
      self.$el.addClass('active');
      self.$el.addClass(opts.className);
    }, 0);
    opts.onshow && opts.onshow();
    return self;
  },

  close: function close() {
    ableMouseWheel();
    var self = this,
        opts = self.opts;
    self.$el.removeClass('active');
    self.$box.hide();
    setTimeout(function () {
      self.$el.hide();
      setTimeout(function () {
        self._destroy();
      }, 500);
    }, 350);
    opts.onclose && opts.onclose();
    return self;
  },

  on: function on() {
    var self = this,
        $el = self.$el;
    $el.on.apply($el, Array.prototype.slice.call(arguments));
    return self;
  },

  find: function find(selector) {
    return this.$box.find(selector);
  },

  _destroy: function _destroy() {
    this.$el.remove();
    this.$el = null;
    this.$box = null;
  },

  _initEvents: function _initEvents() {
    var self = this;
    self.opts.maskclose && self.$el.on('click', 'div.pcqb-dialog-mask', function (e) {
      self.close();
    });
    self.$el.on('click', '.submit', function (e) {
      self.close();
      self.opts.onclose && self.opts.onclose();
    });
    self.$el.on('click', '.close', function (e) {
      self.close();
    });
    self.$el.on('click', '.addres', function (e) {
      self.close();
      self.opts.onclose && self.opts.onclose();
      lottery.getUserContact(); //todo 耦合性太高
    });
  },

  _createElement: function _createElement() {
    var $el = $(template({
      body: this.opts.body
    }));
    this.$el = $el;
    this.$box = $el.find('div.dialog-wrap');
    $body.append($el);
  }

};

/***/ }),
/* 22 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 23 */
/***/ (function(module, exports) {

module.exports = function (obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="dialog-container"><div class="dialog-mask"></div><div class="dialog-wrap"><span class="close">✕</span><div class="dialog-body"> ' +
((__t = (body)) == null ? '' : __t) +
' </div></div></div>';

}
return __p
}

/***/ }),
/* 24 */
/***/ (function(module, exports) {

module.exports = function (obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="dialog-qb-down"><div class="qb-down prize"><p> ' +
((__t = (title)) == null ? '' : __t) +
' </p><p> ' +
((__t = (msg)) == null ? '' : __t) +
' </p><div class="btn"><a class="downQb" id="downloadQBBtn" href="https://dldir1.qq.com/invc/tt/QQBrowser_Setup_QB10.exe" onclick="_qblog.wsd.click(\'LOVEAPARTMENT.QBDOWN.CLICK\');">下载QQ浏览器</a></div></div></div>';

}
return __p
}

/***/ }),
/* 25 */
/***/ (function(module, exports) {

module.exports = function (obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="dialog-myGifts"><div class="giftRecord prize"><div class="tit">获奖记录</div><div class="gifts"></div></div></div>';

}
return __p
}

/***/ }),
/* 26 */
/***/ (function(module, exports) {

module.exports = function (obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="dialog-show-prize"><div class="gifts"></div></div>';

}
return __p
}

/***/ }),
/* 27 */
/***/ (function(module, exports) {

module.exports = function (obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="dialog-share-getChance"><div class="notShare sma"><p>抽奖机会已用完，分享到以下任意渠道，</p><p>额外获得1次抽奖机会，追剧成功后即可生效！</p><div class="logo">分享至： <span class="QZ" onclick="lottery.shareTo(\'qzone\');"></span> <span class="WB" onclick="lottery.shareTo(\'sina\')"></span> <span class="QQ" onclick="lottery.shareTo(\'qq\')"></span></div></div></div>';

}
return __p
}

/***/ }),
/* 28 */
/***/ (function(module, exports) {

module.exports = function (obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="dialog-common"><div class="notSub sma"><p>请订阅后再参与抽奖，据说手气更旺！</p><div class="btn"><a href="javascript:void(0)" onclick="lottery.sub(true);" class="close closeSub">订阅并抽奖</a></div></div></div>';

}
return __p
}

/***/ }),
/* 29 */
/***/ (function(module, exports) {

module.exports = function (obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="dialog-common"><div class="outtime sma"><p> ' +
((__t = (title)) == null ? '' : __t) +
' </p><p> ' +
((__t = (msg)) == null ? '' : __t) +
' </p><div class="btn"><a href="javascript:void(0)" class="close">我知道了</a></div></div></div>';

}
return __p
}

/***/ }),
/* 30 */
/***/ (function(module, exports) {

module.exports = function (obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="dialog-user-contact"><div id="userCon"><div class="tit">填写联系方式</div><div class="userInfo"></div><div class="sub submit" onclick="lottery.setUserContact()">确认提交</div><div class="contact-hint"><span>提交后如需修改地址，请在本活动页面【获奖记录】中操作</span></div></div><div id="success-submit">提交成功</div></div>';

}
return __p
}

/***/ }),
/* 31 */
/***/ (function(module, exports) {

module.exports = function (obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="dialog-answer-end"><div class="answer-end"><p class="body">需要把4个题答完再交卷哦~</p><div class="btn"><a href="javascript:void(0)" class="close">我知道了</a></div></div></div>';

}
return __p
}

/***/ }),
/* 32 */
/***/ (function(module, exports) {

module.exports = function (obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="dialog-answer-first"><div class="answer-first"><div class="answer-title"><span class="title"> ' +
((__t = (title)) == null ? '' : __t) +
' </span></div><p class="body">一菲的“弹一闪”，美嘉的“盐汽水”还是熟悉的配方，还是原来的味道！“一菲”演唱的主题曲《最好的朋友在身边》是不是勾起了很多的美好回忆？那就拉上好友8月10日影院见吧</p><div class="btn"><a class="goWatch close" id="goWatch" href="javascript:void(0);">我知道了</a></div><div class="tryluck" style="display: none;">抽奖机会+1&nbsp;去试试手气</div></div></div>';

}
return __p
}

/***/ }),
/* 33 */
/***/ (function(module, exports) {

module.exports = function (obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="dialog-common dialog-common-littlemask"><div class="hd"> ' +
((__t = (title)) == null ? '' : __t) +
' </div><div class="mask-little-tit-msg"> ' +
((__t = (msg)) == null ? '' : __t) +
' </div><div class="little-flow-btn ft"><button class="close" style="font-size:18px">我知道了</button></div></div>';

}
return __p
}

/***/ }),
/* 34 */
/***/ (function(module, exports) {

module.exports = function (obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="dialog-qb-down"><div class="qb-down prize"><p> ' +
((__t = (title)) == null ? '' : __t) +
' </p><p>注：前往浏览器顶部右上角<span class="skin-icon"></span></p><p>进入皮肤中心，可恢复成默认皮肤</p><div class="btn"><a class="downQb close">我知道了</a></div></div></div>';

}
return __p
}

/***/ }),
/* 35 */
/***/ (function(module, exports) {

module.exports = function (obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="dialog-common dialog-common-littlemask"><div class="hd"> ' +
((__t = (title)) == null ? '' : __t) +
' </div><div class="mask-little-tit-msg"> ' +
((__t = (msg)) == null ? '' : __t) +
' </div><div class="little-flow-btn ft"><button class="toFankui" style="font-size:18px" onclick="lottery.toFankui();">我要反馈</button></div></div>';

}
return __p
}

/***/ }),
/* 36 */
/***/ (function(module, exports) {

module.exports = function (obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="dialog-common dialog-common-littlemask"><div class="hd"> ' +
((__t = (title)) == null ? '' : __t) +
' </div><div class="mask-little-tit-msg">好遗憾，还差一点点就中奖啦~<p class="little-thanks">去参与测试，抽奖机会+1</p></div><div class="little-flow-btn ft"><button class="close" style="font-size:18px">我知道了</button></div></div>';

}
return __p
}

/***/ }),
/* 37 */
/***/ (function(module, exports) {

module.exports = function (obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="dialog-common dialog-common-littlemask" style="position: relative;top: -40px;"><div class="mask-little-tit-msg">亲，你已经抽过奖了啦<p class="little-thanks"><a href="http://i.browser.qq.com/" target="_blank" style="color:#e50156;text-decoration: underline;">个人中心</a>&nbsp;还有很多福利</p><p class="little-thanks">凭已有积分可以兑换更多奖品哦</p></div><div class="little-flow-btn ft" style="margin-top: 42px"><button class="close" style="font-size:18px">我知道了</button></div></div>';

}
return __p
}

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(39);
var mask = __webpack_require__(0);

$(window).scroll(function () {
  if ($(this).scrollTop() > 250) {
    $("#acMoive").attr('src', 'https://v.qq.com/iframe/player.html?vid=x0712z4hxk1&tiny=1&auto=1');
    $(this).unbind();
  }
});

var questionNum = 1;

var questFirst = {
  id: 1,
  // num:'01',
  dry: '1.“弹一闪”是《爱情公寓》中谁的绝招？',
  anfirst: ' A. 曾小贤',
  ansecond: ' B. 胡一菲',
  anthird: ' C. 唐悠悠'
};

var questSecond = {
  id: 2,
  // num:'02',
  dry: '2.“我一口盐汽水喷死你”是《爱情公寓》中谁的经典台词？',
  anfirst: ' A. 吕子乔',
  ansecond: ' B. 张伟',
  anthird: ' C. 陈美嘉'
};

var questThird = {
  id: 3,
  // num:'03',
  dry: '3.电影《爱情公寓》上映时间是？',
  anfirst: ' A. 8月10日',
  ansecond: ' B. 9月17日',
  anthird: ' C. 11月11日'
};

var questFour = {
  id: 4,
  // num:'04',
  dry: '4.电影《爱情公寓》的主题曲《最好的朋友在身边》是由谁演唱的？',
  anfirst: ' A. 韦正',
  ansecond: ' B. 娄艺潇',
  anthird: ' C. 爱情公寓全体'
};

var $answer = $("input[name=answerone]");
var AQ = [];

// 上一题
$('.previous').click(function () {

  _qblog.wsd.click("LOVEAPARTMENT.PREQUEST");
  $answer.attr("checked", false);
  questionNum--;
  if (questionNum >= 1) {
    getHtml(questionNum);
  } else {
    questionNum = 1;
  }
});

// 下一题
$('.next').click(function () {
  _qblog.wsd.click("LOVEAPARTMENT.NEXTQUEST");
  zUtil.ensureLogin(function () {
    $answer.attr("checked", false);
    questionNum++;
    if (questionNum <= 4) {
      getHtml(questionNum);
    } else {
      questionNum = 4;
    }
  });
});

// 取radio值
$('input').click(function () {
  AQ[questionNum - 1] = $('input[name="answerone"]:checked').attr('value');
});

// 提交
$('.finish').click(function () {

  if (AQ[0] === undefined || AQ[1] === undefined || AQ[2] === undefined || AQ[3] === undefined) {
    mask('answerEnd');
    return;
  } //2312
  window.lottery.vote();
  var answerArr = [0, 0, 0, 0];
  var right = 0;
  for (var index = 0; index < 4; index++) {
    if (AQ[index] == 1) {
      answerArr[0]++;
    } else if (AQ[index] == 2) {
      answerArr[1]++;
    } else if (AQ[index] == 3) {
      answerArr[2]++;
    } else if (AQ[index] == 4) {
      answerArr[3]++;
    }
  }
  if (AQ[0] == 2) {
    right++;
  }
  if (AQ[1] == 3) {
    right++;
  }
  if (AQ[2] == 1) {
    right++;
  }
  if (AQ[3] == 2) {
    right++;
  }
  var fenshu = right * 25;
  var answerNumId = getMaxId(answerArr);
  mask('answerNum', '测试结果：' + fenshu + '分', '');

  // if (answerNumId == 0) {
  //   // 选A多
  //   mask('answerNum', '你在剧中的人物是：书澈（罗晋饰演）', '你追求个性和自我实现，正如剧中的书澈，出污泥而不染，以一己之力对抗时代和社会的某种潜规则。', 'http://stdl.qq.com/stdl/qb/kp/aa.png')
  // } else if (answerNumId == 1) {
  //   // 选B
  //   mask('answerNum', '你在剧中的人物是：萧清（唐嫣饰演）', '你心思缜密、沉着冷静，就像萧清能果断地在理智和情感间进行取舍、在爱情与正义间进行抉择。', 'http://stdl.qq.com/stdl/qb/kp/bb.png')
  // } else if (answerNumId == 2) {
  //   // 选C
  //   mask('answerNum', '你在剧中的人物是：宁鸣（于济玮饰演）', '你内心热情，但是却行事内敛。如同剧中的宁鸣，他出身于工薪阶级，却因为一段一见钟情却注定无果的暗恋而屡次挑战现实，最终一步步完成了蜕变。', 'http://stdl.qq.com/stdl/qb/kp/cc.png')
  // } else {
  //   // 选D
  //   mask('answerNum', '你在剧中的人物是：缪盈', '你是传说中别人家的孩子，事事为他人考虑。剧中的缪盈也是如此，出身富裕人家，从小身负家族使命，对自己要求严格，面对挫折和坎坷也能始终坚持前行。', 'http://stdl.qq.com/stdl/qb/kp/dd.png')
  // }
  // 提交后清空数值
  getHtml(1);
  $answer.removeAttr("checked");
  questionNum = 1;
  AQ = [];
  answerArr = [0, 0, 0, 0];
  answerNumId = 0;
});

// 取数组最大值的索引
function getMaxId(arr) {
  // 将数组第一个元素的值赋给max
  var arrmax = arr[0];
  var arrnum = 0;
  // 使用for 循环从数组第一个值开始做遍历
  for (var i = 1; i < arr.length; i++) {
    // 如果元素当前值大于max,就把这个当前值赋值给max
    if (arr[i] > arrmax) {
      arrmax = arr[i];
      arrnum = i;
    }
  }
  // 返回最大的值的索引
  return arrnum;
}

// 改变题目
function getHtml(num) {
  if (num == 1) {
    // $('.ranswer .spanNum').html('<span>'+ questFirst.num + '</span>')
    $('.answerNum').html(questFirst.id);
    $('.questions .question-dry').html(questFirst.dry);
    $('.questions .one .an-one').html(questFirst.anfirst);
    $('.questions .two .an-two').html(questFirst.ansecond);
    $('.questions .three .an-three').html(questFirst.anthird);
    $('.questions .four .an-four').html(questFirst.anfour);
    $("input[value=" + AQ[num - 1] + "]").attr('checked', 'true');
    $('.previous').css('display', 'none');
    $('.next').css('display', 'inline-block');
    $('.finish').css('display', 'none');
  } else if (num == 2) {
    // $('.ranswer .spanNum').html('<span>'+ questSecond.num + '</span>');
    $('.answerNum').html(questSecond.id);
    $('.questions .question-dry').html(questSecond.dry);
    $('.questions .one .an-one').html(questSecond.anfirst);
    $('.questions .two .an-two').html(questSecond.ansecond);
    $('.questions .three .an-three').html(questSecond.anthird);
    $('.questions .four .an-four').html(questSecond.anfour);
    $("input[value=" + AQ[num - 1] + "]").attr('checked', 'true');
    $('.previous').css('display', 'inline-block');
    $('.next').css('display', 'inline-block');
    $('.finish').css('display', 'none');
  } else if (num == 3) {
    // $('.ranswer .spanNum').html('<span>'+ questThird.num + '</span>');
    $('.answerNum').html(questThird.id);
    $('.questions .question-dry').html(questThird.dry);
    $('.questions .one .an-one').html(questThird.anfirst);
    $('.questions .two .an-two').html(questThird.ansecond);
    $('.questions .three .an-three').html(questThird.anthird);
    $('.questions .four .an-four').html(questThird.anfour);
    $("input[value=" + AQ[num - 1] + "]").attr('checked', 'true');
    $('.previous').css('display', 'inline-block');
    $('.next').css('display', 'inline-block');
    $('.finish').css('display', 'none');
  } else if (num == 4) {
    // $('.ranswer .spanNum').html('<span>'+ questFour.num + '</span>');
    $('.answerNum').html(questFour.id);
    $('.questions .question-dry').html(questFour.dry);
    $('.questions .one .an-one').html(questFour.anfirst);
    $('.questions .two .an-two').html(questFour.ansecond);
    $('.questions .three .an-three').html(questFour.anthird);
    $('.questions .four .an-four').html(questFour.anfour);
    $("input[value=" + AQ[num - 1] + "]").attr('checked', 'true');
    $('.next').css('display', 'none');
    $('.previous').css('display', 'inline-block');
    $('.finish').css('display', 'inline-block');
  }
}

/***/ }),
/* 39 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(41);

$(document).on('click', 'a[data-vid]', function (e) {
  var vid = $(this).data('vid');
  _qblog.wsd.click('LOVEAPARTMENT.RECOMMEND');
  _qblog.wsd.click('LOVEAPARTMENT.' + vid);
});

// 获取视频片单信息
function getVideosInfo() {
  var vidArr = [100225281, 100183445, 100279765, 100337102, 100336420];

  var list = '';
  for (var i = 0; i < vidArr.length; i++) {
    //请求接口http://video.browser.qq.com/api/get_video_info?video_id=
    jQuery.ajax({
      url: "http://video.browser.qq.com/api/get_video_info",
      type: 'get',
      // async: false,
      data: {
        video_id: vidArr[i]
      },
      success: function success(res) {
        var dataNum = res.videoBasic.setNum[0];
        // type == 4 综艺
        if (res.videoBasic.type == 4) {
          list = '更新至' + dataNum.updateSetNum + '集';
        } else {
          if (dataNum.totalSetNum == dataNum.updateSetNum) {
            list = '全' + dataNum.totalSetNum + '集';
          } else {
            list = '更新至' + dataNum.updateSetNum + '集';
          }
        }
        $('.videos .' + res.videoBasic.videoId).html(list);
      }
    });
  }
}

getVideosInfo();

/***/ }),
/* 41 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(43);

/***/ }),
/* 43 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = utils;

function utils() {}

var parseUrlParams = utils.parseUrlParams = function (str) {
  str || (str = '');
  var vars = str.split("&");
  var json = {},
      pair;

  for (var i = 0; i < vars.length; i++) {
    pair = pair.split('=');
    json[pair[0]] = decodeURIComponent(pair[1] || '');
  }
  return json;
};
var getUrlParams = utils.getUrlParams = function (key) {
  var query = window.location.search.substring(1);
  var json = parseUrlParams(query);
  utils.getUrlParams = function (k) {
    return k ? json[k] : json;
  };
  return key ? json[key] : json;
};

utils.animateScrollTo = function (cval, tval, callback) {
  var f = 30,
      dval = tval - cval;

  function __run() {
    dval = dval / 2;
    if (Math.abs(dval) > 1) {
      cval += dval;
      callback(Math.round(cval));
      setTimeout(__run, f);
    } else {
      callback(tval);
    }
  }
  __run();
};
//QQ浏览器判断
utils.isQQBrowser = function () {
  return !/Trident/i.test(navigator.userAgent) && /QQBrowser/i.test(navigator.userAgent) && window.external && window.external.getVersion ? true : false;
};
/**
 * 对日期进行格式化，
 * @param date 要格式化的日期
 * @param format 进行格式化的模式字符串
 *     支持的模式字母有：
 *     y:年,
 *     M:年中的月份(1-12),
 *     d:月份中的天(1-31),
 *     h:小时(0-23),
 *     m:分(0-59),
 *     s:秒(0-59),
 *     S:毫秒(0-999),
 *     q:季度(1-4)
 * @return String
 */
utils.dateFormat = function (date, format) {
  date = new Date(date);

  var map = {
    "M": date.getMonth() + 1, //月份
    "d": date.getDate(), //日
    "h": date.getHours(), //小时
    "m": date.getMinutes(), //分
    "s": date.getSeconds(), //秒
    "q": Math.floor((date.getMonth() + 3) / 3), //季度
    "S": date.getMilliseconds() //毫秒
  };
  format = format.replace(/([yMdhmsqS])+/g, function (all, t) {
    var v = map[t];
    if (v !== undefined) {
      if (all.length > 1) {
        v = '0' + v;
        v = v.substr(v.length - 2);
      }
      return v;
    } else if (t === 'y') {
      return (date.getFullYear() + '').substr(4 - all.length);
    }
    return all;
  });
  return format;
};

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// 来自 http://stdl.qq.com/stdl/tq_center/activity/common/header_footer_v2.js
// 暂时使用，后面需要替换掉这个旧的

(function ($) {
  var userInfo = {};
  var isQB = isQB = isQQBrowser();

  function getUserInfo(cb) {
    zUtil.ensureLogin(function () {
      $.ajax({
        url: 'http://cgi.vip.qq.com/contact/getusercontact',
        type: "get",
        dataType: "jsonp",
        data: {
          g_tk: qq.security.getCSRFToken()
        },
        jsonp: "callback",
        success: function success(json) {
          if (json.ret === 0) {
            userInfo = {
              name: json.data.NAME,
              phone: json.data.PHONE,
              email: json.data.EMAIL,
              address: json.data.POST_ADDR
            };
            cb ? cb(userInfo) : null;
          } else if (json.ret === -7) {
            qq.login.open();
          } else {}
        }
      });
    });
  };

  function setUserInfo(obj, cb) {
    for (var i in obj) {
      obj[i] = obj[i].trim();
    }
    if (obj.name.length == 0) {
      alert('濮撳悕涓嶈兘涓虹┖锛�');
      return;
    } else if (obj.name.length < 2 || !/^[a-zA-Z\u4e00-\u9fa5]{0,}$/.test(obj.name)) {
      alert('濮撳悕涓嶅悎娉曪紝璇烽噸鏂拌緭鍏ワ紒');
      return;
    }
    if (obj.phone.length == 0) {
      alert('鎵嬫満鍙蜂笉鑳戒负绌猴紒');
      return;
    } else if (obj.phone != userInfo.phone) {
      if (isNaN(obj.phone) || obj.phone.length != 11) {
        alert('璇疯緭鍏ユ湁鏁堢殑鎵嬫満鍙凤紒');
        return;
      }
    }
    if (obj.email.length == 0) {
      alert('鐢靛瓙閭涓嶈兘涓虹┖锛�');
      return;
    } else if (!/^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/.test(obj.email)) {
      alert('璇疯緭鍏ユ湁鏁堢殑鐢靛瓙閭锛�');
      return;
    }
    if (obj.address.length == 0) {
      alert('閭瘎鍦板潃涓嶈兘涓虹┖锛�');
      return;
    } else if (!/^[a-zA-Z0-9\u4e00-\u9fa5]{0,}$/.test(obj.address)) {
      alert('闈炴硶鐨勬眽瀛楀拰鑻辨枃瀛楃锛岃閲嶆柊杈撳叆锛�');
      return;
    }
    var _url = 'http://cgi.vip.qq.com/contact/setusercontact?name=' + obj.name + '&phone=' + obj.phone + '&email=' + obj.email + '&post_address=' + obj.address + '&noChange_phone=';
    if (obj.phone == userInfo.phone) {
      _url += "1";
    } else {
      _url += "0";
    }
    var temp = 0;
    for (var k in obj) {
      if (obj[k] == userInfo[k]) {
        temp++;
      }
    }
    if (temp == 4) {
      cb ? cb() : null;
      return;
    }
    zUtil.ensureLogin(function () {
      $.ajax({
        url: _url,
        type: "get",
        dataType: "jsonp",
        data: {
          g_tk: qq.security.getCSRFToken()
        },
        jsonp: "callback",
        success: function success(json) {
          if (json.ret == 0) {
            cb ? cb() : null;
          } else if (json.ret == -7) {
            qq.login.open();
          } else {}
        }
      });
    });
  }

  function initUserInfo(phone) {
    $('body').on('focus', '#' + phone, function () {
      if ($(this).val() == userInfo.phone) {
        $(this).val('');
      }
    });
    $('body').on('blur', '#' + phone, function () {
      if ($(this).val() == '') {
        $(this).val(userInfo.phone);
      }
    });
  }

  function submitUserInfo(name, phone, email, address, cb) {
    userContact = {
      name: $('#' + name).val(),
      phone: $('#' + phone).val(),
      email: $('#' + email).val(),
      address: $('#' + address).val()
    };
    setUserInfo(userContact, function () {
      cb ? cb() : '';
    });
  }

  function report(hottagValue) {
    window.setTimeout(function () {
      try {
        pgvSendClick({
          hottag: hottagValue
        });
      } catch (e) {}
    }, 100);
  }

  function dataReport(a, b, c, d, e, f, g, h, i) {
    window.setTimeout(function () {
      try {
        window.external.dataReport(a, b, c, d, e, f, g, h, i);
      } catch (e) {
        console.log(e);
      }
    }, 100);
  }
  window.setTimeout(function () {
    if (typeof pgvMain == 'function') {
      pgvMain("pathtrace", {
        pathStart: true,
        tagParamName: "ADTAG",
        useRefUrl: true,
        override: true,
        careSameDomainRef: false
      });
    }
  }, 1000);

  function getQBVersion() {
    var version = 0;
    try {
      try {
        version = window.external.getVersion() || 1;
      } catch (e) {
        version = window.external.getbrowserversion() || 1;
      }
    } catch (e) {
      version = /QQBrowser/.test(navigator.userAgent) || "100.0.0.0";
    }
    return version;
  }

  function isQQBrowser() {
    var version = getQBVersion();
    var result = version != "100.0.0.0" && version != 0;
    isQQBrowser = function isQQBrowser() {
      return result;
    };
    return result;
  }

  window.api = {
    setUserInfo: setUserInfo,
    getUserInfo: getUserInfo,
    initUserInfo: initUserInfo,
    submitUserInfo: submitUserInfo,
    report: report,
    dataReport: dataReport,
    getQBVersion: getQBVersion,
    isQQBrowser: isQQBrowser,
    isQB: isQB
  };
})(jQuery);

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// index.js